import { Injectable } from '@angular/core';
import { PouchdbService } from '../../shared/pouchDb.service';
import { Constants } from '../../shared/models/constants'
import { BookData } from '../../shared/models/bookData';
import { ShelfValues } from '../../shared/models/shelfEnums';
import { Page } from '../../shared/models/page';
import { Book } from '../../shared/models/book';
import { Subject } from 'rxjs';

@Injectable()
export class EnrichmentTabsService {
    localDB; remoteDB;
    bookDataObj: BookData = new BookData();
    pdfDoc;
    pageContentData: Subject<any> = new Subject();
    pageContentData$ = this.pageContentData.asObservable();
    constructor(public pouchService: PouchdbService) {
        this.localDB = pouchService.localDB;
        //
    }

    //Update operation - Saving enrichments to the pouchDb
    async update(currentPageNumber, bookDataobj) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookDataobj._id },
        }).then(function (result) {
            if (result.docs.length > 0) {
                if (result.docs[0][currentPageNumber] == undefined) {
                    result.docs[0][currentPageNumber] = {};
                }
                // result.docs[0].lastOpenedPage = currentPageNumber;
                // var pageObj = bookDataobj[currentPageNumber];
                // result.docs[0][currentPageNumber] = pageObj;
                bookDataobj._rev = result.docs[0]._rev;

                result.docs[0] = bookDataobj;

                return self.pouchService.localDB.put(result.docs[0]).then(function (response) {

                }).catch(function (err) {
                    console.log(err);
                });
            }
        }).catch(function (err) {

        });
    }

    async createPageContentDoc(pageContentObj) {
        var self = this;
        await self.pouchService.localDB.put(pageContentObj).then(function (response) {
            console.log("PageContent Created")
        }).catch(function (err) {
            console.log(err);
        });
    }

    getPageContentData(data) {
        this.pageContentData.next(data);

    }

    getPageContent(id) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'pageContent', _id: id },
        }).then(function (result) {
            if (result.docs.length > 0) {

                self.getPageContentData(result.docs[0]);
            }
        }).catch(function (err) {

        });
    }

    getTemplatePageContent(id) {
        var self = this;

        return new Promise((resolve, reject) => {
            self.pouchService.localDB.find({
                selector: { type: 'pageContent', _id: id },
            }).then(function (result) {
                if (result.docs.length > 0) {
                    resolve(result.docs[0]);
                }
            }).catch(function (err) {

            });
        });
    }

    //To retreive enrichments
    getEnrichmentTabs(bookObj, parentScope) {
        var _this = this;
        if (bookObj.bookDataDocId == undefined)
            bookObj.bookDataDocId = "Not Defined";
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookObj.bookDataDocId },
        }).then(function (result) {

            if (result.docs.length > 0) {
                parentScope.setDataObj(result.docs[0]);
            }
        }).catch(function (err) {

        });
    }

    getTemplates(parentScope) {
        return new Promise((resolve, reject) => {
            var scope = this;

            this.pouchService.localDB.find({
                selector: { type: 'pageTemplate' },
            }).then(function (result) {
                if (result.docs.length > 0) {
                    resolve(result.docs);
                }
                else {
                    resolve(undefined);
                }
            }).catch(function (err) {

            });

        });
    }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/enrichmentTabs/enrichmentTabs.service.ts